/**
 * 工艺路线枚举定义
 * 
 * @description 定义工艺路线相关的所有枚举类型
 * @module types/process-route/enums
 * @category ProcessRoute - 工艺路线管理
 * 
 * @backend-source
 * - Model: backend/app/Modules/ProcessRoute/Models/ProcessRoute.php
 *   - ROUTE_TYPE_* 常量 (line 97-100)
 *   - STATUS_* 常量 (line 115-118)
 * 
 * @field-mapping
 * | 枚举 | 后端常量 | 说明 |
 * |------|---------|------|
 * | ProcessRouteType | ROUTE_TYPE_* | 工艺路线类型 |
 * | ProcessRouteStatus | STATUS_* | 工艺路线状态 |
 * 
 * @update-trigger
 * - 后端新增/修改路线类型常量时
 * - 后端新增/修改状态常量时
 * 
 * @validation
 * - 枚举值必须与后端常量值完全一致（包括大小写）
 * - 枚举注释必须与后端 $routeTypeMap 和 $statusMap 一致
 * 
 * @last-updated 2025-10-18
 * @status ✅ 已验证
 */

/**
 * 工艺路线类型
 * 
 * @backend ProcessRoute::ROUTE_TYPE_*
 */
export enum ProcessRouteType {
  /** 标准工艺 */
  STANDARD = 'STANDARD',
  
  /** 备选工艺 */
  ALTERNATIVE = 'ALTERNATIVE',
  
  /** 试制工艺 */
  TRIAL = 'TRIAL',
  
  /** 淘汰工艺 */
  OBSOLETE = 'OBSOLETE',
}

/**
 * 工艺路线状态
 * 
 * @backend ProcessRoute::STATUS_*
 */
export enum ProcessRouteStatus {
  /** 草稿 */
  DRAFT = 'DRAFT',
  
  /** 生效 */
  ACTIVE = 'ACTIVE',
  
  /** 冻结 */
  FROZEN = 'FROZEN',
  
  /** 淘汰 */
  OBSOLETE = 'OBSOLETE',
}

